import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function LatestUpdate() {
  const latest = movies
    .filter((m) => m.isNew)
    .slice(0, 8);

  const allRecent = [...movies]
    .sort((a, b) => b.year - a.year)
    .slice(0, 8);

  const displayList = latest.length >= 4 ? latest : allRecent;

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              热门剧集持续更新中
            </p>
          </div>
          <Link
            to="/category/variety"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {displayList.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/variety"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}